import LineChartApex from './LineChartApex';

export default LineChartApex;